// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".productImgSmall_biFqI{max-height:100%}.productImgSmall_biFqI img{height:100%;-o-object-fit:contain;object-fit:contain;width:100%}.zoomOff_eZKOo{cursor:zoom-in}.zoomOn_q1dMh{cursor:zoom-out}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productImgSmall": "productImgSmall_biFqI",
	"zoomOff": "zoomOff_eZKOo",
	"zoomOn": "zoomOn_q1dMh"
};
module.exports = ___CSS_LOADER_EXPORT___;
